import Network from 'lib/api/network';

export default {
  namespaced: true,

  state() {
    return {
      teamPulseSummary: null,
      loading: false,
    };
  },

  actions: {
    fetchChannelPulseReports() {
      return new Promise((resolve) => {
        Network.get('/team_pulse/channel_pulse_reports', {
          success: (data) => {
            resolve(data);
          },
          error: () => {
            // Keep polling quiet; a transient failure should not interrupt the page.
            resolve(null);
          },
        });
      });
    },

    fetchTeamPulseSummary({ commit }) {
      commit('update', { module: 'teamPulse', key: 'loading', value: true }, { root: true });
      return new Promise((resolve) => {
        Network.get('/team_pulse/team_pulse_summary', {
          success: (data) => {
            commit('update', { module: 'teamPulse', key: 'teamPulseSummary', value: data }, { root: true });
            resolve(data);
          },
          error: () => {
            commit('update', { module: 'teamPulse', key: 'teamPulseSummary', value: null }, { root: true });
            resolve(null);
          },
          complete: () => {
            commit('update', { module: 'teamPulse', key: 'loading', value: false }, { root: true });
          },
        });
      });
    },
  },
};

